import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { IspettoratiComponent } from 'src/app/anagrafiche/ispettorati/ispettorati.component';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => IspettoratoPickerComponent) },
  ],
  selector: 'ispettorato-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class IspettoratoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(IspettoratiComponent, {
      data: {
        selectionMode: true,
        defaultSearch: this.defaultSearch,
      }
    }).afterClosed();
  };


}
